module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sticky', {
    attrs: {
      "top": "5rem"
    }
  }, [_c('div', {
    staticClass: "summary bg-lightest darker relative border-light"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('summary-header', {
    attrs: {
      "tag": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('date-and-time', {
    attrs: {
      "reservation": _vm.getClonedReservation
    }
  }), _vm._v(" "), (_vm.pricePerOrder) ? _c('table', {
    staticClass: "table bare"
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.pricePerOrder.label))]), _vm._v(" "), _c('td', [(_vm.product.includeTaxes) ? _c('div', [_vm._v("\n                            " + _vm._s(_vm.formatPrice(_vm.pricePerOrder.value - (_vm.pricePerOrder.value * _vm.product.tax * 0.01))) + "€\n                        ")]) : _c('div', [_vm._v("\n                            " + _vm._s(_vm.formatPrice(_vm.pricePerOrder.value)) + "€\n                        ")])])])]) : _c('table', {
    staticClass: "table bare"
  }, _vm._l((_vm.prices), function(price) {
    return _c('tr', [_c('td', {
      staticClass: "text-lowercase"
    }, [_vm._v("\n                        " + _vm._s(price.quantity) + "x " + _vm._s(price.title) + "\n                    ")]), _vm._v(" "), _c('td', [(_vm.product.includeTaxes) ? _c('div', [_vm._v("\n                            " + _vm._s(_vm.formatPrice((price.value - (price.value * _vm.product.tax * 0.01)) * price.quantity)) + "€\n                        ")]) : _c('div', [_vm._v("\n                            " + _vm._s(_vm.formatPrice(price.value * price.quantity)) + "€\n                        ")])])])
  }), 0), _vm._v(" "), (_vm.addedExtras) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Extras")]), _vm._v(" "), _c('table', {
    staticClass: "table bare"
  }, _vm._l((_vm.extras), function(extra) {
    return (extra.item.quantity > 0) ? _c('tr', [_c('td', [_vm._v("\n                            " + _vm._s(extra.item.quantity) + "x " + _vm._s(extra.item.name))]), _vm._v(" "), _c('td', [(extra.priceIncluded) ? _c('div', [_vm._v("\n                                -\n                            ")]) : _c('div', [(extra.item.priceIncludeTaxes && extra.item.vatType != 0) ? _c('div', [_vm._v("\n                                    " + _vm._s(_vm.formatPrice((extra.item.priceTotal - (extra.item.priceTotal * extra.item.vatType * 0.01)) * extra.item.quantity)) + "€\n                                ")]) : _c('div', [_vm._v("\n                                    " + _vm._s(_vm.formatPrice(extra.item.priceTotal * extra.item.quantity)) + "€\n                                ")])])])]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.activeTransport) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Transport")]), _vm._v(" "), _c('table', {
    staticClass: "table bare"
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(2) + "x Seats")]), _vm._v(" "), _c('td', [_vm._v(_vm._s((10 * 2).toFixed(2)) + "€")])])])]) : _vm._e(), _vm._v(" "), (_vm.chosenPayment) ? _c('div', {
    staticClass: "my-3 fs-small"
  }, [_vm._v("\n                " + _vm._s(_vm.chosenPayment.description) + "\n            ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('summary-totals', {
    attrs: {
      "reservation": _vm.getClonedReservation,
      "product": _vm.product,
      "chosenDeposit": _vm.chosenDeposit,
      "chosenPayment": _vm.chosenPayment
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex buttons"
  }, [_c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelReservation
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider ml-3",
    attrs: {
      "type": "button",
      "disabled": !_vm.buttonEnabled
    },
    on: {
      "click": _vm.saveAndPay
    }
  }, [_vm._v("Save & Pay")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7ed9d1cb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed9d1cb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/summary/Summary.vue
// module id = 2744
// module chunks = 0